<template>
  <v-card class="pa-6">
    <FormPortals
      ref="mainModal"
      :labelBtn="labelBtn"
      :dialog.sync="dialog"
      :selectedItem="selectedPortal"
    />
    <BaseDataTable
      :headers="headerTable"
      :items="itemsPortais"
      :loading="loading"
      :items-per-page="8"
      :paginate="true"
      :lastPage="lastPage"
      :currentPage="currentPage"
      @pageChange="fetchPortals({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="pa-0 d-flex align-center">
          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              v-can:permission="'portal-acesso#store'"
              @click="openModal()"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por portal'"
              :textQuery="'descricao'"
              :codQuery="'id'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>
      <!-- ---------------- header ---------------- -->
      <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.url="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :upperCase="false"
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao.toUpperCase() }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip v-can:permission="'logins#list-all'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openLogins(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="primary"
                >mdi-lock</v-icon
              >
            </v-btn>
          </template>
          Logins
        </v-tooltip>
        <v-tooltip v-can:permission="'portal-acesso#update'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openModalEdit(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="warning"
                >mdi-pencil</v-icon
              >
            </v-btn>
          </template>
          Editar portal
        </v-tooltip>
        <v-tooltip v-can:permission="'portal-acesso#delete'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="deletePortal(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="error"
                >mdi-trash-can</v-icon
              >
            </v-btn>
          </template>
          Apagar portal
        </v-tooltip>
      </template>
    </BaseDataTable>
  </v-card>
</template>
<script>
import toast from "@/commom/toast.js";
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import senhas from "@/services/http/rpa/Senhas.js";
import { permissions } from "@/store/permissionsStore";
import FormPortals from "./FormPortals.vue";

export default {
  components: {
    FormPortals,
    MenuFilter,
    BaseDataTable,
    MenuFilterSearchTable,
  },
  data() {
    return {
      portal: {},
      loading: false,
      labelBtn: "",
      dialog: false,
      selectedPortal: "",
      lastPage: 1,
      currentPage: 1,
      itemsPortais: [],
      filter: {},
    };
  },

  watch: {
    filter(value) {
      this.fetchPortals(value);
    },
  },

  computed: {
    tableFilter() {
      return this.tmpTable.filter(
        (item) =>
          item.url.includes(this.url) &&
          item.descricao.includes(this.description)
      );
    },

    headerTable() {
      const permissionUser = permissions();
      let headers = [
        {
          text: "ID",
          value: "id",
          align: "center",
        },
        {
          text: "Portal",
          align: "center",
          sortable: true,
          value: "descricao",
          filterable: true,
        },
        {
          text: "Endereço",
          align: "center",
          value: "url",
          filterable: true,
        },
      ];

      if (permissionUser.getPermissions["logins"].includes("list-all")) {
        headers.push({ text: "Ações", align: "center", value: "action" });
        return headers;
      }

      if (
        permissionUser.getPermissions["portal-acesso"].includes(
          "delete",
          "update"
        )
      ) {
        headers.push({ text: "Ações", align: "center", value: "action" });
      }
      return headers;
    },
  },

  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    openLogins(portal) {
      this.$router.push({ path: `/portal/${portal.id}/logins` });
    },

    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
      if (this.$refs.mainModal.$refs.formGroups)
        this.$refs.mainModal.$refs.formGroups.reset();
    },

    openModalAdd(item) {
      this.dialogContrib = true;
      this.nameGroup = item.nome;
      this.selectedPortal = item;
    },

    openModalEdit(item) {
      this.dialog = true;
      this.labelBtn = "Editar";
      this.selectedPortal = item;
    },

    async closeModal() {
      this.dialog = false;
      await this.fetchPortals(this.filter);
    },

    async fetchPortals(filters) {
      try {
        this.loading = true;
        let { data } = await senhas().show({ ...filters, per_page: 8 });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        
        // Validação: filtrar IDs 143 e 383 se o usuário não for admin
        const permissionUser = permissions();
        const isAdmin = permissionUser.getRoles.includes("admin");
        
        if (!isAdmin) {
          this.itemsPortais = data.data.filter(
            item => item.id !== 143 && item.id !== 383
          );
        } else {
          this.itemsPortais = data.data;
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deletePortal(item) {
      let res = await this.$swal({
        title: "Você tem certeza?",
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar login",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await senhas(item.id).delete();
        toast("success", "Login removido");
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.fetchPortals(this.filter);
        //this.fetchLogins();
      }
    },
  },
  async created() {
    await this.fetchPortals();
  }
};
</script>
<style>
@import "../../../../assets/style/style.css";
</style>
